import CloseIcon from '@mdi/svg/svg/close.svg?react';
import { Flex, MDIIconButton } from '@solinkcorp/solink-components';
import { getLocalTimeZone } from '@solinkcorp/utils';
import FormattedTime from 'components/FormattedTime';
import React from 'react';
import useLocale from 'src/hooks/useLocale';
import styles from './AuditLog.module.sass';
import { type AuditLogList } from './useAuditLog';

interface AuditLogProps {
  auditLog: AuditLogList | undefined;
  isLoading: boolean;
  toggleAuditLog: () => void;
}

const AuditLog: React.FC<AuditLogProps> = ({ auditLog, isLoading, toggleAuditLog }) => {
  const locale = useLocale();

  return (
    <div className={styles.auditLog}>
      <Flex alignItems="center" justifyContent="space-between" className={styles.auditLogHeader}>
        <div>{locale.eventFlow.auditLog}</div>
        <MDIIconButton
          title={locale.general.close}
          icon={CloseIcon}
          onClick={toggleAuditLog}
          fill={'var(--color-white)'}
          iconSize={20}
          className={styles.closeButton}
        />
      </Flex>
      <div className={styles.auditLogEntries}>
        {isLoading && <div>{locale.general.loading}...</div>}
        {!isLoading &&
          auditLog &&
          auditLog.map((entry, index) => {
            const previousEntry = auditLog[index - 1];
            return (
              <div className={styles.auditLogEntry} key={entry.updatedTime}>
                <div>
                  <span>
                    <FormattedTime
                      date={entry.updatedTime}
                      withDate="date-first"
                      dateFormatString={locale.date.format1}
                      timezoneId={getLocalTimeZone()}
                    />
                    {': '}
                  </span>
                  <span>
                    {`"${
                      entry.type === 'add'
                        ? entry.answer
                        : previousEntry?.type === 'add'
                          ? previousEntry.answer
                          : ''
                    }"`}
                  </span>
                </div>
                <div className={styles.auditLogEntryBy}>
                  {entry.type === 'add' ? locale.eventFlow.addedBy : locale.eventFlow.removedBy}{' '}
                  {entry.updatedBy}
                </div>
              </div>
            );
          })}
        {!isLoading && !auditLog && <div>{locale.eventFlow.noAuditLog}</div>}
      </div>
    </div>
  );
};

export default AuditLog;
